import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useLocalization } from '../contexts/LocalizationContext';
import api, { getApiImageUrl } from '../services/api';
import './DragonSelection.css';

const DragonSelection = ({ currentPlayer }) => {
  const [selectedDragon, setSelectedDragon] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { } = useAuth(); // Auth handled by api service
  const { t } = useLocalization();

  const dragons = [
    { id: 'sea-dragon', name: 'Sea Dragon', color: '#2196F3' },
    { id: 'wind-dragon', name: 'Wind Dragon', color: '#4CAF50' },
    { id: 'golden-dragon', name: 'Golden Dragon', color: '#FFC107' },
    { id: 'dark-dragon', name: 'Dark Dragon', color: '#9C27B0' },
    { id: 'ice-dragon', name: 'Ice Dragon', color: '#00BCD4' },
    { id: 'grass-dragon', name: 'Grass Dragon', color: '#8BC34A' }
  ];

  const handleSelection = async () => {
    if (!selectedDragon) return;

    setLoading(true);
    setError('');

    try {
      const response = await api.post('/api/dragons/select', { 
        dragon_name: selectedDragon,
        player_id: currentPlayer?.id
      });

      if (response.status !== 200) {
        throw new Error(response.data.error || 'Failed to select dragon');
      }

      // Dragon selected successfully
      // Note: Choice resolution might not be needed if dragon selection already handles it
      
      // Play selection sound
      const audio = new Audio('/app/api/audio/dragon-selected.wav');
      audio.play().catch(err => console.log('Failed to play sound:', err));

      // Navigate back to play screen to continue with modules
      setTimeout(() => {
        navigate('/play');
      }, 1000);

    } catch (err) {
      console.error('Error selecting dragon:', err);
      setError(err.message);
      setLoading(false);
    }
  };

  return (
    <div className="dragon-selection-screen">
      <div className="selection-content">
        <h1 className="selection-title">
          {t('dragon.chooseYourDragon') || 'Choose Your Dragon Egg'}
        </h1>
        
        <p className="selection-subtitle">
          {t('dragon.chooseWisely') || 'Choose wisely - this will be your companion throughout your journey!'}
        </p>

        <div className="dragon-grid">
          {dragons.map(dragon => (
            <div 
              key={dragon.id}
              className={`dragon-option ${selectedDragon === dragon.id ? 'selected' : ''}`}
              onClick={() => setSelectedDragon(dragon.id)}
              style={{ '--dragon-color': dragon.color }}
            >
              <div className="egg-container">
                <img 
                  src={getApiImageUrl(`/api/dragons/image/${dragon.id}/egg.png`)}
                  alt={dragon.name}
                  className="dragon-egg-image"
                />
              </div>
              <div className="dragon-name">{dragon.name}</div>
            </div>
          ))}
        </div>

        {error && (
          <div className="error-message">{error}</div>
        )}

        <button 
          className="confirm-button"
          onClick={handleSelection}
          disabled={!selectedDragon || loading}
        >
          {loading 
            ? (t('common.selecting') || 'Selecting...') 
            : (t('dragon.confirmSelection') || 'Confirm Selection')}
        </button>
      </div>
    </div>
  );
};

export default DragonSelection;